<template>
  <div class="email-rightbar">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="card-title">
              <h5 class="float-left">
                {{ collectionName.name }}
              </h5>
              <b-button
                v-if="collectionName.name != 'Customers'"
                variant="danger"
                class="btn btn-label btn-primary float-right"
                @click="deleteCollection()"
              >
                <i class="bx bx-trash label-icon"></i>
                Delete Collection
              </b-button>
              <b-button
                v-if="collectionName.name != 'Customers'"
                style="margin: 0px 20px 0px 20px"
                @click="updateDatabaseWithDraggableArray"
                variant="primary"
                class="btn btn-label btn-primary float-right"
                ><i class="bx bx-save label-icon"></i>Save Collection</b-button
              >
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-xl-12 col-lg-12 col-md-12">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="itemsPerPage"
                      size="sm"
                      :options="pageLengthOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label
                    v-if="collectionName.name == 'Customers'"
                    class="d-inline-flex align-items-center"
                  >
                    Search:
                    <b-form-input
                      v-if="collectionName.name == 'Customers'"
                      v-model="itemFilter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <content-loader
                primaryColor="#d3d3d3"
                v-if="
                  tempTableData.length == 0 &&
                  collectionName.name == 'Customers'
                "
              >
                <rect x="8" y="5" rx="3" ry="3" width="88" height="5" />
                <rect x="112" y="5" rx="3" ry="3" width="279" height="5" />
                <rect x="8" y="20" rx="3" ry="3" width="88" height="5" />
                <rect x="112" y="20" rx="3" ry="3" width="279" height="5" />
                <rect x="8" y="35" rx="3" ry="3" width="88" height="5" />
                <rect x="112" y="35" rx="3" ry="3" width="279" height="5" />
                <rect x="8" y="50" rx="3" ry="3" width="88" height="5" />
                <rect x="112" y="50" rx="3" ry="3" width="279" height="5" />
                <rect x="8" y="65" rx="3" ry="3" width="88" height="5" />
                <rect x="112" y="65" rx="3" ry="3" width="279" height="5" />
                <rect x="8" y="80" rx="3" ry="3" width="88" height="5" />
                <rect x="112" y="80" rx="3" ry="3" width="279" height="5" />
                <rect x="8" y="95" rx="3" ry="3" width="88" height="5" />
                <rect x="112" y="95" rx="3" ry="3" width="279" height="5" />
                <rect x="8" y="110" rx="3" ry="3" width="88" height="5" />
                <rect x="112" y="110" rx="3" ry="3" width="279" height="5" />
              </content-loader>
              <!-- Customers Table -->
              <b-table
                :items="tempTableData"
                :fields="tableHeaders"
                responsive="sm"
                :per-page="itemsPerPage"
                :current-page="currentPage"
                :sort-by.sync="itemSortBy"
                :sort-desc.sync="itemSortDesc"
                :filter="itemFilter"
                :filter-included-fields="itemFilterOn"
                v-if="
                  tempTableData.length > 0 && collectionName.name == 'Customers'
                "
                foot-clone
                class="customerTable"
              >
                <template v-slot:cell(edit)="data">
                  <b-dropdown variant="primary" size="sm">
                    <template v-slot:button-content>
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item
                      @click="
                        deleteItem(
                          data.item.edit,
                          data.item.sage_id,
                          data.item.qb_id,
                          data.item.qb_sync_token,
                          data.index
                        )
                      "
                      ><i class="bx bx-trash mr-2 tableIcons"></i
                      >Delete</b-dropdown-item
                    >
                  </b-dropdown>
                </template>
                <template #foot(edit)="">
                  <b-form-input
                    ref="addItemInput"
                    v-model="newItemValue"
                    v-on:keyup.enter="addItem"
                    class="float-left mr-2"
                  />
                </template>
                <template #foot(name)="">
                  <b-button v-on:click="addItem" variant="primary">
                    Add Item
                  </b-button>
                </template>
              </b-table>
              <!-- / Customers Table -->

              <!-- Draggable Table -->
              <b-table-simple v-if="collectionName.name != 'Customers'">
                <draggable
                  handle=".handle"
                  :class="{ [`cursor-grabbing`]: dragging === true }"
                  v-model="tempTableData"
                  @start="dragging = true"
                  @end="dragging = false"
                  @change="dragChanged"
                  tag="tbody"
                >
                  <b-tr v-for="element in tempTableData" :key="element.id">
                    <b-td class="handleColumn"
                      ><i class="handle bx bx-grid-horizontal"></i
                    ></b-td>
                    <b-td class="handleColumn">
                      <b-dropdown variant="primary" size="sm">
                        <template v-slot:button-content>
                          <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <b-dropdown-item
                          @click="deleteFromDraggableArray(element)"
                          ><i class="bx bx-trash mr-2 tableIcons"></i
                          >Delete</b-dropdown-item
                        >
                      </b-dropdown>
                      <!-- </template> -->
                    </b-td>

                    <b-td>{{ element.name }}</b-td>
                    <b-td>{{ element.source }}</b-td>
                  </b-tr>
                </draggable>
              </b-table-simple>
            </div>

            <div inline v-if="collectionName.name != 'Customers'">
              <b-form-input
                ref="addItemInput"
                v-model="newItemValue"
                v-on:keyup.enter="addToDraggableArray"
                class="float-left mr-2"
                style="width: 50%"
              />
              <b-button v-on:click="addToDraggableArray" variant="primary">
                Add Item
              </b-button>
              <!-- </template> -->
            </div>
            <!-- / Draggable Table -->
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-if="collectionName.name == 'Customers'"
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="itemsPerPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!--/Row-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { ContentLoader } from 'vue-content-loader';
import VueToast from 'vue-toast-notification';
import Swal from 'sweetalert2';
import firebase from 'firebase';

import draggable from 'vuedraggable';
import 'vue-toast-notification/dist/theme-sugar.css';

import { addCustomCollectionItem } from '../helper/dbHelpers.js';

Vue.use(VueToast);

export default {
  components: {
    ContentLoader,
    draggable,
  },
  props: ['collectionName', 'tableData', 'tableHeaders', 'totalRows'],
  data() {
    return {
      saveButtonClicked: false,
      addedItemToTable: false,
      deletedItemFromTable: false,
      dragDropMoved: false,
      dragging: false,
      itemsPerPage: 10,
      currentPage: 1,
      pageLengthOptions: [10, 25, 50, 100],
      itemFilter: null,
      itemFilterOn: [],
      itemSortBy: null,
      itemSortDesc: false,
      newItemValue: null,
      newItemError: {
        error: false,
        message: null,
      },
      currentUser: this.$store.state.custom.currentUserData,
      tempTableData: this.tableData, //placeholder to avoid mutating prop.
    };
  },
  watch: {
    saveButtonClicked() {
      this.swalPopupBooleanHandler();
    },
    tableData(newValue) {
      this.tempTableData = newValue; // Update when the prop changes
    },
    itemsPerPage(newVal, oldVal) {
      // make sure current user is updated
      this.currentUser = this.$store.state.custom.currentUserData;

      if (newVal !== oldVal) {
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_adminCollection){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_adminCollection;
          }
          currentUserDataCopy.tablePageLengths['perPage_adminCollection'] =
            newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_adminCollection: newVal,
          };
        }

        if (
          oldCurrentUserPerPage !== newVal
        ) {
          try {
            firebase
              .firestore()
              .collection('employees')
              .doc(this.currentUser.auth)
              .update({
                tablePageLengths: currentUserDataCopy.tablePageLengths,
              });
          } catch (err) {
            console.log('Error updating user table settings in db: ', err);
          }
        }
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
  },
  methods: {
    swalPopupBooleanHandler() {
      if (
        (this.dragDropMoved ||
          this.addedItemToTable ||
          this.deletedItemFromTable) &&
        !this.saveButtonClicked
      ) {
        this.$emit('popUpHandler', true);
      } else {
        this.$emit('popUpHandler', false);
      }
    },
    updateDatabaseWithDraggableArray() {
      this.saveButtonClicked = true;

      let newArray = this.tempTableData.map((o) => o.name);

      addCustomCollectionItem(this.collectionName, newArray)
        .then(() => {
          Vue.$toast.open({
            message: 'Collection Successfully Updated',
            type: 'success',
            duration: 4000,
            position: 'top-right',
          });

          //clear the add input.
          // this.$refs.collectionTableChild.clearAddInput();
        })
        .catch(() => {
          Swal.fire(
            'Error!',
            'An error was encountered while adding the item to the collection.',
            'error'
          );
        });
      //reset the booleans after save button is clicked
      // this.saveButtonClicked = false;
      // this.addedItemToTable = false;
      // this.deletedItemFromTable = false;
      // this.dragDropMoved = false;
    },
    deleteFromDraggableArray(element) {
      let indexOfItemToDelete = this.tempTableData.indexOf(element);
      this.tempTableData.splice(indexOfItemToDelete, 1);
      this.deletedItemFromTable = true;
      this.saveButtonClicked = false;
      this.swalPopupBooleanHandler();
    },
    addToDraggableArray() {
      try {
        if (this.newItemValue != null && this.newItemValue.trim() != '') {
          this.newItemError.error = false;
          let index = this.tempTableData.find(
            (o) => o.name == this.newItemValue
          );
          if (index != undefined) {
            Vue.$toast.open({
              message: 'Item already exists in the collection.',
              type: 'error',
              duration: 4000,
              position: 'top-right',
            });
          } else {
            this.addedItemToTable = true;
            this.saveButtonClicked = false;
            this.tempTableData.push({ edit: '', name: this.newItemValue });
            this.clearAddInput();
            this.swalPopupBooleanHandler();
          }
        } else {
          Vue.$toast.open({
            message: 'Value cannot be empty',
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
        }
      } catch {
        Vue.$toast.open({
          message: 'An error occurred.',
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
    dragChanged() {
      this.dragDropMoved = true;
      this.saveButtonClicked = false;
      this.swalPopupBooleanHandler();
    },
    deleteItem: function (edit, sage_id, qb_id, qb_sync_token, index) {
      //emit the value to the pareant component and it cant handle the logic of what collection is being viewed.
      Swal.fire({
        title: 'Are you sure?',
        text: 'This item will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.$emit('deleteCollectionItem', {
            edit,
            sage_id,
            qb_id,
            qb_sync_token,
            index,
          });
        }
      });
    },
    addItem: function () {
      try {
        if (this.newItemValue != null && this.newItemValue.trim() != '') {
          this.newItemError.error = false;
          //emit the value to the parent component and it will do the logic for adding it to the db.
          this.$emit('addCollectionItem', this.newItemValue);
        } else {
          Vue.$toast.open({
            message: 'Value cannot be empty',
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
        }
      } catch {
        Vue.$toast.open({
          message: 'An error occurred.',
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
    clearAddInput: function () {
      this.newItemValue = null;
      this.$refs.addItemInput.focus();
    },
    deleteCollection: function () {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This item will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.$emit('deleteCollection');
        }
      });
    },
    setTableSettings: function () {
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_adminCollection) {
          this.itemsPerPage =
            this.currentUser.tablePageLengths.perPage_adminCollection;
        }
      }
    },
  },
  mounted: function () {
    this.setTableSettings();
  },
};
</script>
